import { render, staticRenderFns } from "./SystemUpdate.vue?vue&type=template&id=a27b71a0&scoped=true&"
import script from "./SystemUpdate.vue?vue&type=script&lang=js&"
export * from "./SystemUpdate.vue?vue&type=script&lang=js&"
import style0 from "./SystemUpdate.vue?vue&type=style&index=0&id=a27b71a0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a27b71a0",
  null
  
)

export default component.exports